<template>
  <div class="toast-global-container position-fixed top-0 start-50 translate-middle-x p-3" style="z-index: 1100"></div>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*, *::before, *::after {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
}

/* Remove the margin-top that was pushing everything down */
#app, #app-root {
  margin: 0 !important;
  padding: 0 !important;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* Scoped styles with !important where needed */
:root {
  --primary-color: #4F46E5 !important;
  --primary-hover: #4338CA !important;
  --primary-light: #E0E7FF !important;
  --primary-subtle: rgba(67, 56, 202, 0.1) !important;
}

.btn-primary {
  background-color: var(--primary-color) !important;
  color: white !important;
  padding: 8px 16px !important;
  border-radius: 4px !important;
  border: none !important;
  cursor: pointer !important;
}

.btn-primary:hover {
  background-color: var(--primary-hover) !important;
}

.bg-primary {
  background-color: var(--primary-color) !important;
}

.bg-primary-subtle {
  background-color: var(--primary-subtle) !important;
}

.border-primary-subtle {
  border-color: var(--primary-subtle) !important;
}

.text-primary {
  color: var(--primary-color) !important;
}

.border-primary {
  border-color: var(--primary-color) !important;
}

.main-title span {
  font-size: 30px !important;
}
.main-title {
  color:black !important;
}
/* badges */
.badge-warning-subtle {
  background-color: #fff3e0;
  color: #ed6c02;
}

.badge-success-subtle {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.badge-danger-subtle {
  background-color: #ffebee;
  color: #d32f2f;
}

.badge-primary-subtle {
  background-color: #e3f2fd;
  color: #1976d2;
}

.badge-secondary-subtle {
  background-color: #f5f5f5;
  color: #757575;
}

.badge-info-subtle {
  background-color: #e0f7fa;
  color: #0097a7;
}

.badge-dark-subtle {
  background-color: #eceff1;
  color: #455a64;
}

.fs-10 {
  font-size: 10px;
}
/* Base Table */
/* Sortable headers */
.sortable {
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;
}

.sortable:hover {
  background: #e9ecef;
}

.sortable i {
  margin-left: 6px;
  font-size: 12px;
  transition: all 0.2s;
}

.text-muted {
  color: #adb5bd;
}

/* Pagination Styles - Compact Version */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-top: 16px; */
  padding: 12px 0 8px 0;
  flex-wrap: wrap;
  gap: 12px;
}

.pagination-info {
  font-size: 12px;
  color: #6c757d;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

/* Previous / Next Buttons */
.pagination-btn {
  padding: 4px 10px;
  border: 1px solid #dee2e6;
  background: white;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #495057;
}

.pagination-btn i {
  font-size: 10px;
}

.pagination-btn:hover:not(:disabled) {
  background: #f8f9fa;
  border-color: #adb5bd;
  color: var(--primary-color);
}

.pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Page Numbers Container */
.page-numbers {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Individual Page Number Buttons */
.page-btn {
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  border: 1px solid #dee2e6;
  background: white;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  color: #495057;
}

.page-btn:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.page-btn.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

/* Ellipsis style */
.page-numbers span {
  min-width: 24px;
  text-align: center;
  font-size: 12px;
  color: #6c757d;
}

/* Page Size Selector - Compact */
.page-size-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  justify-content: flex-end;
}

.page-size-label {
  font-size: 11px;
  color: #6c757d;
}

.page-size-select {
  padding: 3px 6px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 11px;
  background: white;
  cursor: pointer;
}

/* Custom Scrollbar for Table Wrapper */
.data-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 13px;
  text-align: left;
}

/* Table Headers */
.data-table thead th {
  padding: 2px 4px;
  background: #efefef;
  font-size: 12px;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 1px solid #e9ecef;
  white-space: nowrap;
}

/* Table Cells */
.data-table tbody td {
  padding: 6px 4px;
  border-bottom: 1px solid #f0f2f5;
  vertical-align: left;
  font-size: 12px;
  color: black;
  font-weight: 400;
}

/* Hover Effect */
.data-table tbody tr:hover td {
  background: #f8f9fa;
}

/* Even More Compact (Ultra) - Use if needed */
.data-table-compact thead th {
  padding: 6px 10px;
  font-size: 11px;
}

.data-table-compact tbody td {
  padding: 6px 10px;
  font-size: 12px;
}

/* Status Badges (Compact) */
.status-badge {
  display: inline-block;
  padding: 2px 4px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;
}

.status-online {
  background: #d1e7dd;
  color: #0f5132;
}

.status-offline {
  background: #f8d7da;
  color: #842029;
}

.status-warning {
  background: #fff3cd;
  color: #997404;
}

/* Criticality Badges (Compact) */
.criticality-badge {
  display: inline-block;
  padding: 2px 4px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;
}

.criticality-critical {
  background: #dc3545;
  color: white;
}

.criticality-important {
  background: var(--primary-color);
  color: white;
}

.criticality-high {
  background: #f8d7da;
  color: #842029;
}

.criticality-medium {
  background: #fff3cd;
  color: #997404;
}

/* Action Buttons */
.action-btn {
  background: none;
  border: none;
  padding: 4px 6px;
  cursor: pointer;
  color: #6c757d;
  font-size: 12px;
}

.action-btn:hover {
  color: var(--primary-color);
}

/* Responsive Table Wrapper */
.table-wrapper {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

/* Zebra Striping (Optional) */
.data-table-striped tbody tr:nth-child(even) td {
  background: #fafbfc;
}

/* Fixed Header (If needed) */
.data-table-fixed {
  display: block;
  overflow-y: auto;
  max-height: 70vh;
}

.data-table-fixed thead {
  position: sticky;
  top: 0;
  background: #f8f9fa;
}

.material-symbols-outlined {
  font-size: 18px;
  vertical-align: middle;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px !important;
}

/* ===============================================
   FINAL CSS - SELECT2 EXACT SAME SIZE AS OTHER FIELDS
=============================================== */

/* Modal width */
.modal-dialog {
  max-width: 800px !important;
  width: 95% !important;
  margin: 1rem auto !important;
}

.modal-content {
  border-radius: 0.5rem;
  overflow: hidden;
}

/* Thin modal header */
.modal-header {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  background-color: var(--primary-color);
  border-bottom: 1px solid var(--primary-color);
}

.modal-header .modal-title {
  color: white;
  font-weight: 600;
  font-size: 1.2rem;
}

.modal-header .btn-close {
  filter: brightness(0) invert(1);
  opacity: 0.85;
  background-size: 0.7rem;
  padding: 0.5rem;
}

/* Modal body */
.modal-body {
  padding: 0.75rem 1rem;
  text-align: left !important;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-footer {
  margin-bottom: -15px !important;
  padding: 10px !important;
  border-top: none !important;
}

/* ========== ALL INPUT FIELDS - BASE SIZE 28px ========== */
.form-control-thin,
.form-select-thin,
select.form-select-thin,
select.form-control-thin,
input.form-control-thin,
textarea.form-control-thin {
  height: 32px !important;
  min-height: 28px !important;
  padding: 0.2rem 0.4rem !important;
  font-size: 0.85rem !important;
  line-height: 1.2 !important;
  border-radius: 0.2rem !important;
  background-color: #ffffff !important;
  border: 1px solid #ced4da !important;
  color: #212529 !important;
  transition: none !important;
}

/* Textarea */
textarea.form-control-thin {
  height: auto !important;
  min-height: 50px !important;
  max-height: 80px !important;
}

/* Select dropdown arrow */
.form-select-thin,
select.form-select-thin {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right 0.4rem center !important;
  background-size: 10px 10px !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  cursor: pointer !important;
  padding-right: 1.5rem !important;
}

/* Select options */
.form-select-thin option,
select.form-select-thin option {
  color: #212529 !important;
  background-color: #ffffff !important;
  font-size: 0.75rem !important;
}

/* Focus state */
.form-control-thin:focus,
.form-select-thin:focus {
  border: 2px solid var(--primary-color) !important;
  /* box-shadow: 0 0 0 0.15rem rgba(13, 110, 253, 0.2) !important; */
}

/* ========== PLACEHOLDER - SMALL SIZE ========== */
.form-control-thin::placeholder,
input.form-control-thin::placeholder,
textarea.form-control-thin::placeholder {
  font-size: 0.75rem !important;
  color: #adb5bd !important;
  opacity: 1 !important;
}

.form-control-thin::-moz-placeholder {
  font-size: 0.75rem !important;
  color: #adb5bd !important;
}

/* select2 css */


/* Labels */
.form-label-thin {
  margin-bottom: 0.15rem !important;
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c3e50;
  display: block;
  text-align: left;
}

/* Hint text */
.text-hint {
  font-size: 0.6rem;
  color: #6c757d;
  margin-top: 0.15rem;
  display: block;
  text-align: left;
}

/* Error messages */
.error-message {
  color: #dc3545;
  font-size: 0.6rem;
  margin-top: 0.15rem;
  display: block;
  text-align: left;
}

.is-invalid {
  border-color: #dc3545 !important;
}

/* Form spacing */
.mb-3 {
  margin-bottom: 0.6rem !important;
}

/* Modal footer */
.modal-footer {
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.4rem;
  border-top: 1px solid #dee2e6;
}

.modal-footer .btn {

  padding: 0.2rem 0.6rem;
}

/* Remove center alignment */
.modal,
.modal-dialog,
.modal-content,
.modal-body,
form {
  text-align: left !important;
}

.btn:focus {
  box-shadow: none;
}

.text-danger {
  color: #dc3545;
  font-size: 0.7rem;
}
.tad-menu {
  background: #fff;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 10px;
  padding: 4px;
  width: 38px;
  min-width: 38px;
  overflow: hidden;
  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 25px rgba(0,0,0,0.08);
  margin-left: auto;
}
.tad-menu:hover {
  width: 130px;
}


.tad-menu:hover {
  width: 150px;
}

.tad-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 8px; 
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  border-radius: 6px;
  white-space: nowrap;
  transition: background .15s, color .15s;
  cursor: pointer;
  line-height: 1;
  margin-bottom: 2px;
  overflow: hidden;
}

.tad-menu .dropdown-item:last-child {
  margin-bottom: 0;
}

.tad-menu .dropdown-item i {
  font-size: 16px;
  width: 18px;
  text-align: center;
  flex-shrink: 0;
  color: #9ca3af;
  transition: color .15s;
    margin-left: -1px;
}

.tad-menu .dropdown-item span {
  opacity: 0;
  transform: translateX(-5px);
  transition: opacity .2s ease, transform .2s ease;
  /* Ensure text doesn't overflow */
  overflow: hidden;
  text-overflow: ellipsis;
}

.tad-menu:hover .dropdown-item span {
  opacity: 1;
  transform: translateX(0);
}

/* Default hover */
.tad-menu .dropdown-item:hover {
  background: #f3f4f6;
  color: #111827;
}
.tad-menu .dropdown-item:hover i {
  color: #534AB7;
}

/* Delete / danger */
.tad-menu .dropdown-item.item-danger {
  color: #dc2626;
}
.tad-menu .dropdown-item.item-danger i {
  color: #f87171;
}
.tad-menu .dropdown-item.item-danger:hover {
  background: #fef2f2;
  color: #b91c1c;
}
.tad-menu .dropdown-item.item-danger:hover i {
  color: #dc2626;
}

.tad-menu .dropdown-divider {
  margin: 4px 4px;
  border: none;
  border-top: 1px solid rgba(0,0,0,0.07);
}
</style>
<!-- import styles -->
 <style>


/* ── Shared color icon helpers ────────────────────────────── */
.icon-blue   { background: #dbeafe; color: #1d4ed8; }
.icon-green  { background: #dcfce7; color: #15803d; }
.icon-red    { background: #fee2e2; color: #b91c1c; }
.icon-orange { background: #FDE8CC; color: #A0500A; }
 
/* ── Instructions card ────────────────────────────────────── */
.instructions-card {
  position: relative;
  padding: 20px 24px 16px;
  background: #F8F7F2;
  border: 1px solid #E4E2D9;
  border-radius: 12px;
}
 
.instructions-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.instructions-icon  { font-size: 18px; color: #f5a623; }
.instructions-title { font-size: 14px; font-weight: 600; color: #2c3e50; }
 
/* ── Steps row ────────────────────────────────────────────── */
.steps-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: nowrap;
}
.step-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid #E4E2D9;
}
.step-number {
  width: 24px; height: 24px;
  background: #4A4844; color: white;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 700; flex-shrink: 0;
}
.step-icon-wrap {
  width: 40px; height: 40px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; flex-shrink: 0;
}
.step-text  { flex: 1; }
.step-title { font-size: 13px; font-weight: 600; color: #1f2937; margin-bottom: 4px; }
.step-desc  { font-size: 11px; color: #6b7280; }
.step-divider  { color: #cbd5e1; font-size: 12px; flex-shrink: 0; }
.highlight-red { color: #dc2626; font-weight: 500; }
 
/* ── Download button (top-right of instructions card) ─────── */
.download-btn-wrapper {
  position: absolute;
  top: 16px; right: 20px;
  z-index: 5;
}
.btn-download {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: #fff;
  border: none;
  border-radius: 50px;
  font-size: 13px; font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  letter-spacing: 0.3px;
}
.btn-download:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(40, 167, 69, 0.4);
  color: #fff;
  background: linear-gradient(135deg, #218838 0%, #1aa179 100%);
}
.btn-download:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
}
.btn-download i { font-size: 14px; }
 
/* ── Column reference alert ───────────────────────────────── */
.col-ref-alert {
  background: #e7f1ff;
  border: 1px solid #b6d4fe;
  border-radius: 6px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  color: #0a2a4a;
}
 
/* ── Upload section header ────────────────────────────────── */
.upload-header {
  display: flex; align-items: center;
  gap: 10px; margin-bottom: 16px; flex-wrap: wrap;
}
.upload-icon { font-size: 18px; color: #3b82f6; }
.section-label {
  font-size: 11px; font-weight: 600;
  color: #4a5568; letter-spacing: 0.04em;
  text-transform: uppercase;
}
 
/* ── Drop zone ────────────────────────────────────────────── */
.drop-zone {
  position: relative;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 2rem 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafaf8;
}
.drop-zone:hover     { border-color: #3b82f6; background: #eff6ff; }
.drop-zone.drag-over { border-color: #2563eb; background: #dbeafe; }
.drop-zone.has-file  { border-color: #22c55e; background: #f0fdf4; }
 
.dz-input          { position: absolute; inset: 0; opacity: 0; cursor: pointer; }
.dz-icon           { font-size: 36px; color: #94a3b8; margin-bottom: 12px; display: block; }
.has-file .dz-icon { color: #22c55e; }
.dz-title          { font-size: 13px; font-weight: 500; margin-bottom: 8px; color: #334155; }
.dz-hint           { font-size: 11px; color: #64748b; }
.dz-hint code      { background: #e2e8f0; padding: 2px 6px; border-radius: 4px; font-size: 10px; }
 
.dz-file-row {
  display: flex; align-items: center; justify-content: center;
  gap: 8px; margin-top: 12px; padding: 6px 12px;
  background: #dcfce7; border-radius: 30px;
  width: fit-content; margin-left: auto; margin-right: auto;
}
.dz-file-name { font-size: 12px; font-weight: 500; color: #166534; }
.dz-file-size {
  font-size: 10px; color: #15803d;
  background: #bbf7d0; padding: 2px 8px; border-radius: 20px;
}
 
/* ── Stats row ────────────────────────────────────────────── */
.stats-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.stat-card {
  background: #f8fafc; border-radius: 12px;
  padding: 12px 16px; display: flex; align-items: center;
  gap: 12px; border: 1px solid #e2e8f0;
}
.stat-icon {
  width: 40px; height: 40px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px;
}
.stat-label { font-size: 10px; color: #64748b; text-transform: uppercase; font-weight: 500; }
.stat-val   { font-size: 22px; font-weight: 600; }
.stat-val.blue  { color: #1e40af; }
.stat-val.green { color: #166534; }
.stat-val.red   { color: #991b1b; }
 
/* ── Tabs ─────────────────────────────────────────────────── */
.tab-group {
  display: flex; gap: 4px;
  background: #f1f5f9; border-radius: 10px;
  padding: 4px; width: fit-content;
}
.tab-btn {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 6px 14px; border-radius: 8px; border: none;
  background: transparent; font-size: 12px; font-weight: 500;
  color: #475569; cursor: pointer;
}
.tab-btn:hover:not(.tab-active) { background: #e2e8f0; }
.tab-active {
  background: white; color: #0f172a;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.tab-dot           { width: 7px; height: 7px; border-radius: 50%; display: inline-block; }
.dot-all           { background: #94a3b8; }
.dot-success       { background: #22c55e; }
.dot-fail          { background: #ef4444; }
.tab-count         { font-size: 9px; padding: 1px 6px; border-radius: 30px; }
.count-all         { background: #e2e8f0; color: #334155; }
.count-success     { background: #dcfce7; color: #15803d; }
.count-fail        { background: #fee2e2; color: #b91c1c; }
 
/* ── Result pills ─────────────────────────────────────────── */
.result-pill {
  display: inline-flex; align-items: center;
  gap: 5px; padding: 3px 10px;
  border-radius: 30px; font-size: 10px; font-weight: 500;
}
.pill-s { background: #dcfce7; color: #15803d; }
.pill-f { background: #fee2e2; color: #b91c1c; }
 
/* ── Responsive ───────────────────────────────────────────── */
@media (max-width: 768px) {
  .steps-row    { flex-wrap: wrap; }
  .step-divider { display: none; }
  .col-ref-alert { font-size: 12px; padding: 8px 12px; }
  .download-btn-wrapper {
    position: relative; top: auto; right: auto;
    display: flex; justify-content: flex-end;
    margin-bottom: 12px;
  }
  .btn-download { padding: 6px 14px; font-size: 12px; }
}
@media (max-width: 480px) {
  .btn-download span { display: none; }
  .btn-download i    { margin-right: 0 !important; }
  .btn-download      { padding: 8px 14px; }
}
.action-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    padding: 0 18px;
    border-radius: 100px;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.action-btn i {
    font-size: 13px;
}

/* Back Button */
.action-btn-back {
    background: #f1f3f5;
    color: #868e96;
    border: 1px solid #dee2e6;
}
.action-btn-back:hover {
    background: #e9ecef;
    color: #495057;
    border-color: #ced4da;
}

/* Edit Button */
.action-btn-primary {
    background: var(--bs-primary);
    color: #fff;
    border: 1px solid transparent;
}
.action-btn-primary:hover {
    filter: brightness(0.92);
    color: #fff;
}
</style>


<!-- profile designs -->
<style>

/* ── Design tokens ──────────────────────────────────────────────── */
:root {
  --pp-accent:          #4642c9;
  --pp-accent-light:    #eeedfe;
  --pp-accent-border:   #cecbf6;
  --pp-accent-text:     #4f66ec;
 
  /* Surfaces */
  --pp-bg-page:         #f4f5f9;
  --pp-bg-card:         #ffffff;
  --pp-bg-field:        #fafafa;
  --pp-bg-foot:         #f7f7fb;
 
  /* Borders */
  --pp-border:          #ebebf0;
  --pp-border-soft:     #f0f0f5;
 
  /* Shadows */
  --pp-shadow-card:     0 1px 4px rgba(83,74,183,.05), 0 0 0 1px #ebebf0;
  --pp-shadow-hover:    0 4px 16px rgba(83,74,183,.10);
 
  /* Text */
  --pp-text-primary:    #1a1a2e;
  --pp-text-secondary:  #6c757d;
  --pp-text-muted:      #9a9aaa;
 
  /* Radii */
  --pp-radius-card:     14px;
  --pp-radius-field:    10px;
  --pp-radius-pill:     100px;
  --pp-radius-chip:     6px;
 
  /* Semantic colours (status) */
  --pp-green-bg:        #e1f5ee;
  --pp-green-text:      #0F6E56;
  --pp-green-border:    #9fe1cb;
  --pp-amber-bg:        #faeeda;
  --pp-amber-text:      #854F0B;
  --pp-amber-border:    #fac775;
  --pp-red-bg:          #fdecea;
  --pp-red-text:        #A32D2D;
  --pp-red-border:      #f7c1c1;
  --pp-blue-bg:         #e6f1fb;
  --pp-blue-text:       #185FA5;
  --pp-blue-border:     #b5d4f4;
}
 
/* ── Page wrapper ──────────────────────────────────────────────── */
.profile-page {
  background: var(--pp-bg-page);
  min-height: 100vh;
  padding: 1.5rem 0 3rem;
}
 
/* ── Breadcrumb ────────────────────────────────────────────────── */
.profile-breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: var(--pp-text-muted);
  margin-bottom: 1.25rem;
}
.profile-breadcrumb a {
  color: var(--pp-text-muted);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: color .15s;
}
.profile-breadcrumb a:hover { color: var(--pp-text-primary); }
.profile-breadcrumb .sep   { color: var(--pp-border); }
.profile-breadcrumb .current {
  color: var(--pp-text-primary);
  font-weight: 500;
}
 
/* ── Header card ───────────────────────────────────────────────── */
.profile-header {
  background: var(--pp-bg-card);
  border-radius: var(--pp-radius-card);
  box-shadow: var(--pp-shadow-card);
  padding: 18px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.profile-header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: var(--pp-accent-light);
  color: var(--pp-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}
.profile-header-body { flex: 1; min-width: 0; }
.profile-header-body h3 {
  font-size: 15.5px;
  font-weight: 600;
  color: var(--pp-text-primary);
  margin: 0 0 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.profile-header-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 12px;
  color: var(--pp-text-muted);
}
.profile-header-meta i { font-size: 13px; vertical-align: -1px; margin-right: 3px; }
.profile-actions { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
 
/* ── Stat bar ──────────────────────────────────────────────────── */
.profile-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.profile-stat-card {
  background: var(--pp-bg-card);
  border-radius: var(--pp-radius-card);
  box-shadow: var(--pp-shadow-card);
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.profile-stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}
.profile-stat-icon.c-accent   { background: var(--pp-accent-light); color: var(--pp-accent); }
.profile-stat-icon.c-success  { background: var(--pp-green-bg);     color: var(--pp-green-text); }
.profile-stat-icon.c-warning  { background: var(--pp-amber-bg);     color: var(--pp-amber-text); }
.profile-stat-icon.c-info     { background: var(--pp-blue-bg);      color: var(--pp-blue-text); }
.profile-stat-icon.c-danger   { background: var(--pp-red-bg);       color: var(--pp-red-text); }
.profile-stat-label {
  font-size: 10.5px;
  font-weight: 600;
  color: var(--pp-text-muted);
  text-transform: uppercase;
  letter-spacing: .5px;
  margin-bottom: 5px;
}
.profile-stat-value {
  font-size: 20px;
  font-weight: 500;
  color: var(--pp-text-primary);
  line-height: 1;
}
.profile-stat-value.v-success { color: var(--pp-green-text); }
.profile-stat-value.v-warning { color: var(--pp-amber-text); }
.profile-stat-value.v-accent  { color: var(--pp-accent); }
 
/* ── Generic card ──────────────────────────────────────────────── */
.profile-card {
  background: var(--pp-bg-card);
  border-radius: var(--pp-radius-card);
  box-shadow: var(--pp-shadow-card);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
 
/* ── Card header bar ───────────────────────────────────────────── */
.profile-card-header {
  padding: 13px 18px;
  border-bottom: 1px solid var(--pp-border-soft);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.profile-section-title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--pp-text-primary);
}
.profile-section-title i {
  font-size: 15px;
  color: var(--pp-accent);
}
 
/* ── Card body ─────────────────────────────────────────────────── */
.profile-card-body {
  padding: 18px;
  flex: 1;
}
.profile-card-body.flush { padding: 0; }
 
/* ── Field grid (label above value) ────────────────────────────── */
.profile-field-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px 16px;
}
.profile-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 12px 14px;
  border-radius: var(--pp-radius-field);
  background: var(--pp-bg-field);
  border: 1px solid var(--pp-border-soft);
}
.profile-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--pp-text-muted);
  text-transform: uppercase;
  letter-spacing: .6px;
}
.profile-value {
  font-size: 13px;
  font-weight: 400;
  color: var(--pp-text-primary);
  line-height: 1.45;
  word-break: break-word;
}
.profile-value a {
  color: var(--pp-accent);
  text-decoration: none;
}
.profile-value a:hover { text-decoration: underline; }
.profile-value.v-accent  { color: var(--pp-accent-text);  font-weight: 500; }
.profile-value.v-success { color: var(--pp-green-text);   font-weight: 500; }
.profile-value.v-warning { color: var(--pp-amber-text);   font-weight: 500; }
.profile-value.v-danger  { color: var(--pp-red-text);     font-weight: 500; }
.profile-value.v-info    { color: var(--pp-blue-text);    font-weight: 500; }
 
/* ── Avatar ────────────────────────────────────────────────────── */
.profile-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
.profile-avatar.c-accent   { background: var(--pp-accent-light); color: var(--pp-accent-text); }
.profile-avatar.c-success  { background: var(--pp-green-bg);     color: var(--pp-green-text); }
.profile-avatar.c-info     { background: var(--pp-blue-bg);      color: var(--pp-blue-text); }
.profile-avatar.c-warning  { background: var(--pp-amber-bg);     color: var(--pp-amber-text); }
 
/* ── Note / quote block ────────────────────────────────────────── */
.profile-note {
  background: var(--pp-bg-field);
  border: 1px solid var(--pp-border-soft);
  border-radius: var(--pp-radius-field);
  padding: 10px 13px;
  font-size: 12.5px;
  color: var(--pp-text-secondary);
  font-style: italic;
  line-height: 1.65;
}
 
/* ── Table ─────────────────────────────────────────────────────── */
.profile-table {
  width: 100%;
  font-size: 12.5px;
  border-collapse: collapse;
}
.profile-table thead tr { border-bottom: 1px solid var(--pp-border-soft); }
.profile-table thead th {
  padding: 8px 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: var(--pp-text-muted);
  white-space: nowrap;
  text-align: left;
  background: transparent;
}
.profile-table thead th:first-child { padding-left: 18px; }
.profile-table thead th:last-child  { padding-right: 18px; }
.profile-table tbody tr { border-bottom: 1px solid var(--pp-border-soft); transition: background .12s; }
.profile-table tbody tr:last-child { border-bottom: none; }
.profile-table tbody tr:hover { background: var(--pp-bg-field); }
.profile-table tbody td { padding: 10px 12px; color: var(--pp-text-primary); vertical-align: middle; }
.profile-table tbody td:first-child { padding-left: 18px; }
.profile-table tbody td:last-child  { padding-right: 18px; }
.profile-table .item-name { font-weight: 500; font-size: 13px; color: var(--pp-text-primary); }
.profile-table .item-sku  { font-size: 10.5px; color: var(--pp-text-muted); margin-top: 1px; }
 
/* ── Total footer bar ──────────────────────────────────────────── */
.profile-total-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  padding: 12px 18px;
  background: var(--pp-bg-foot);
  border-top: 1px solid var(--pp-border-soft);
}
.profile-total-label {
  font-size: 10.5px;
  font-weight: 600;
  color: var(--pp-text-muted);
  text-transform: uppercase;
  letter-spacing: .5px;
}
.profile-total-value {
  font-size: 20px;
  font-weight: 700;
  color: var(--pp-accent);
}
 
/* ── Badges / chips ────────────────────────────────────────────── */
.profile-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: var(--pp-radius-pill);
  font-size: 11px;
  font-weight: 600;
  border: 1px solid transparent;
  line-height: 1.65;
}
.profile-badge.c-accent   { background: var(--pp-accent-light); color: var(--pp-accent-text); border-color: var(--pp-accent-border); }
.profile-badge.c-success  { background: var(--pp-green-bg);     color: var(--pp-green-text);  border-color: var(--pp-green-border); }
.profile-badge.c-warning  { background: var(--pp-amber-bg);     color: var(--pp-amber-text);  border-color: var(--pp-amber-border); }
.profile-badge.c-danger   { background: var(--pp-red-bg);       color: var(--pp-red-text);    border-color: var(--pp-red-border); }
.profile-badge.c-info     { background: var(--pp-blue-bg);      color: var(--pp-blue-text);   border-color: var(--pp-blue-border); }
.profile-badge.c-neutral  { background: #f4f5f9; color: var(--pp-text-secondary); border-color: var(--pp-border); }
 
/* Count pill (e.g. "5 items" in card header) */
.profile-count-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: var(--pp-radius-pill);
  font-size: 10.5px;
  font-weight: 600;
  background: var(--pp-accent-light);
  color: var(--pp-accent-text);
}
 
/* ── Attachment grid ───────────────────────────────────────────── */
.profile-attachment {
  border: 1px solid var(--pp-border);
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background: var(--pp-bg-card);
  transition: transform .15s ease, box-shadow .15s ease;
}
.profile-attachment:hover {
  transform: translateY(-2px);
  box-shadow: var(--pp-shadow-hover);
}
.profile-attachment-thumb {
  aspect-ratio: 16 / 9;
  background: var(--pp-bg-field);
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--pp-border-soft);
  overflow: hidden;
}
.profile-attachment-thumb img { width: 100%; height: 100%; object-fit: cover; }
.profile-attachment-thumb i   { font-size: 24px; color: var(--pp-text-muted); }
.profile-attachment-meta { padding: 8px 10px; }
.profile-attachment-name {
  font-size: 11.5px;
  font-weight: 500;
  color: var(--pp-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}
.profile-attachment-size { font-size: 10.5px; color: var(--pp-text-muted); }
 
/* ── Empty state ───────────────────────────────────────────────── */
.profile-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1rem;
  text-align: center;
  background: var(--pp-bg-field);
  border: 1px dashed var(--pp-border);
  border-radius: var(--pp-radius-field);
  color: var(--pp-text-muted);
}
.profile-empty i   { font-size: 28px; opacity: .4; margin-bottom: 10px; }
.profile-empty p   { font-size: 12.5px; margin: 0; }
 
/* ── Timeline / logs ───────────────────────────────────────────── */
.profile-timeline { list-style: none; padding: 0; margin: 0; position: relative; }
.profile-timeline::before {
  content: '';
  position: absolute;
  left: 14px; top: 0; bottom: 0;
  width: 1px;
  background: var(--pp-border);
}
.profile-timeline-item { display: flex; gap: 14px; padding-bottom: 18px; position: relative; }
.profile-timeline-item:last-child { padding-bottom: 0; }
.profile-timeline-dot {
  width: 28px; height: 28px;
  border-radius: 50%;
  background: var(--pp-bg-field);
  border: 1.5px solid var(--pp-border);
  display: flex; align-items: center; justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
  position: relative; z-index: 1;
  color: var(--pp-text-muted);
}
.profile-timeline-dot.active {
  background: var(--pp-accent-light);
  border-color: var(--pp-accent-border);
  color: var(--pp-accent);
}
.profile-timeline-content { padding-top: 3px; }
.profile-timeline-title { font-size: 12.5px; font-weight: 500; color: var(--pp-text-primary); margin-bottom: 2px; }
.profile-timeline-time  { font-size: 11px; color: var(--pp-text-muted); }
 
/* ── Action buttons ────────────────────────────────────────────── */
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 18px;
  border-radius: var(--pp-radius-pill);
  font-size: 12.5px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background .15s, color .15s, filter .15s;
  white-space: nowrap;
  line-height: 1;
}
.action-btn i { font-size: 13px; }
 
.action-btn-back    { background: #f1f3f5; color: var(--pp-text-secondary); border-color: var(--pp-border); }
.action-btn-back:hover { background: #e9ecef; color: var(--pp-text-primary); border-color: #d0d3d9; }
 
.action-btn-primary { background: var(--pp-accent); color: #fff; border-color: var(--pp-accent); }
.action-btn-primary:hover { filter: brightness(.9); color: #fff; }
 
.action-btn-success { background: var(--pp-green-text); color: #fff; border-color: var(--pp-green-text); }
.action-btn-success:hover { filter: brightness(.9); color: #fff; }
 
.action-btn-danger  { background: #fff; color: var(--pp-red-text); border-color: var(--pp-red-border); }
.action-btn-danger:hover { background: var(--pp-red-bg); }
 
.action-btn-outline { background: #fff; color: var(--pp-text-secondary); border-color: var(--pp-border); }
.action-btn-outline:hover { background: var(--pp-bg-field); color: var(--pp-text-primary); border-color: #d0d3d9; }
 
.action-btn-icon {
  width: 34px; height: 34px;
  padding: 0;
  justify-content: center;
  border-radius: 10px;
  background: var(--pp-bg-field);
  color: var(--pp-text-secondary);
  border-color: var(--pp-border);
}
.action-btn-icon:hover { background: #e9ecef; color: var(--pp-text-primary); }
 
/* ── Responsive ────────────────────────────────────────────────── */
@media (max-width: 991.98px) {
  .profile-stats { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 767.98px) {
  .profile-page { padding: 1rem 0 2rem; }
  .profile-header { flex-direction: column; align-items: flex-start; gap: 14px; }
  .profile-actions { width: 100%; }
  .action-btn { flex: 1; justify-content: center; }
  .profile-stats { grid-template-columns: repeat(2, 1fr); }
  .profile-field-grid { grid-template-columns: repeat(2, 1fr); }
  .profile-card-body { padding: 14px; }
}
@media (max-width: 479.98px) {
  .profile-stats { grid-template-columns: 1fr 1fr; }
  .profile-field-grid { grid-template-columns: 1fr; }
}
.activity-timeline {
  display: flex;
  flex-direction: column;
  padding: 4px 0;
}

.activity-item {
  display: flex;
  gap: 14px;
}

/* Icon + connecting line */
.activity-icon-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.activity-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 13px;
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.12);
  flex-shrink: 0;
}

.activity-line {
  flex: 1;
  width: 2px;
  background: linear-gradient(to bottom, rgba(99, 102, 241, 0.35), rgba(99, 102, 241, 0));
  margin: 4px 0;
  min-height: 20px;
}

.activity-item:last-child .activity-line {
  display: none;
}

/* Content */
.activity-body {
  flex: 1;
  padding-bottom: 22px;
  min-width: 0;
}

.activity-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}

.activity-action {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.activity-badge-profile {
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
  color: #6366f1;
  background: rgba(99, 102, 241, 0.1);
  padding: 3px 9px;
  border-radius: 20px;
  white-space: nowrap;
}

/* Meta chips */
.activity-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.activity-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  color: #4b5563;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 3px 8px;
  border-radius: 6px;
  text-transform: capitalize;
}

.activity-meta-chip i {
  font-size: 9px;
  color: #9ca3af;
}

.activity-meta-chip strong {
  color: #1f2937;
  font-weight: 600;
  text-transform: none;
}

/* Footer */
.activity-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11.5px;
  color: #9ca3af;
}

.activity-time,
.activity-log-id {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.activity-time i,
.activity-log-id i {
  font-size: 10px;
}

.activity-log-id {
  font-family: 'SFMono-Regular', Consolas, monospace;
}
.activity-body {
  border-bottom: 1px dashed #e5e7eb;
}
.activity-item:last-child .activity-body {
  border-bottom: none;
  padding-bottom: 0;
}
</style>